(() => {
  if (window.__chicIconFonts) return;
  const script = document.currentScript;
  if (!script) return;
  window.__chicIconFonts = true;
  const known = {
    icons: new Set((script.dataset.chicIconNames || '').split(',')),
    symbols: new Set((script.dataset.chicSymbolNames || '').split(','))
  };
  const selector = '.material-icons,.material-symbols-outlined';
  const originals = new WeakMap();
  function restore(element) {
    if (!originals.has(element)) return;
    const original = originals.get(element);
    if (original.value) element.style.setProperty('font-family', original.value, original.priority);
    else element.style.removeProperty('font-family');
    originals.delete(element);
  }
  function update(element) {
    const type = element.classList.contains('material-symbols-outlined') ? 'symbols' : element.classList.contains('material-icons') ? 'icons' : null;
    const name = element.textContent.trim();
    if (!type || !name || known[type].has(name)) {
      restore(element);
      return;
    }
    if (!originals.has(element)) originals.set(element, {
      value: element.style.getPropertyValue('font-family'),
      priority: element.style.getPropertyPriority('font-family')
    });
    element.style.setProperty('font-family', type === 'symbols' ? '"CHIC Material Symbols Full"' : '"CHIC Material Icons Full"', 'important');
  }
  function scan(root) {
    if (root.nodeType === 1 && (root.matches(selector) || originals.has(root))) update(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(update);
  }
  function initialize() {
    scan(document);
    const pending = new Set();
    let frame = 0;
    function queue(root) {
      if (!root || root.nodeType !== 1) return;
      pending.add(root);
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        pending.forEach(node => { if (node.isConnected) scan(node); });
        pending.clear();
      });
    }
    new MutationObserver(records => {
      records.forEach(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        const icon = target && target.closest(selector);
        if (icon) queue(icon);
        else if (record.type === 'attributes' && originals.has(target)) queue(target);
        if (record.type !== 'childList') return;
        record.addedNodes.forEach(node => {
          if (node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))) queue(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
